import useGetAccount from './useGetAccount'

/**
 * Returns true when the team has the AI Assistant enabled in the backend
 * (toggled by superadmins in Django admin: `team.settings.ai_chatbot_enabled`).
 *
 * Drives sidebar visibility and the `/assistant` route guard.
 */
const useGetIsAiChatbotEnabled = (): boolean => {
  const account = useGetAccount()
  return !!account?.team?.settings?.ai_chatbot_enabled
}

export default useGetIsAiChatbotEnabled
